/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { DataTable } from '@scuf/datatable';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import './ManageTariffTheme.scss';
import MangeTariffTOU from './MangeTariffTOU';
import MangeTariffSlabRate from './MangeTariffSlabRate';
import { Checkbox } from '@scuf/common';

const ManageTariffParent = (props: IAny) => {
  return (
    <div className="Manage-Tariff-Parent">
      <MangeTariffTOU {...props} />
      <div>{/* <MangeTariffSlabRate /> */}</div>
    </div>
  );
};

export default ManageTariffParent;
